import { useQuery } from "react-query";
import Cookies from "js-cookie";
import { serverBaseUrl } from "../config/envs";

const getTasks = async ({
  page = 1,
  limit = 10,
  token = null,
  document_type,
}) => {
  let headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(
    `${serverBaseUrl}/get_all_sign_links?page=${page}&limit=${limit}&document_type=${document_type}`,
    {
      headers,
    }
  );

  if (!response.ok) {
    let errorData = {
      status: response?.status,
      message: response?.statusText,
    };

    try {
      const json = await response.json();
      errorData.message = json.message || errorData.message;
      errorData.messageCode = json.messageCode;
      errorData.data = json.data;
      errorData.success = json.success;
    } catch (jsonError) {
      console.error("Failed to parse JSON error response:", jsonError);
    }

    throw new Error(JSON.stringify(errorData));
  }

  return response.json();
};

export const useGetAllSignLinkDocumentsQuery = ({
  page,
  limit,
  document_type,
}) => {
  const token = Cookies.get("token");

  return useQuery(
    ["get_all_sign_links", page, limit, document_type],
    () => getTasks({ page, limit, token, document_type }),
    {}
  );
};
